import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import resolver from './utils/secure-resolver';

export default function useDevices(host) {
  const options = useMemo(
    () => ({
      shouldReconnect: (closeEvent) => true,
      // share: true,
      reconnectAttempts: 10,
      reconnectInterval: 3000,
    }),
    []
  );

  const getSocketUrl = useCallback(async () => {
    return fetch(host)
      .then((res) => res.json())
      .then((res) => {
        const isServer = res.class.includes('server');
        const searchBy = isServer ? 'self' : 'server';

        return res.links.find((link) => link.rel[0].includes(searchBy)).href;
      })
      .then((url) =>
        fetch(resolver(url))
          .then((res) => res.json())
          .then((res) => res.links.find((link) => link.rel[0].includes('monitor')).href)
      );
  }, [host]);

  const [error, setError] = useState();
  const [lastLog, setLastLog] = useState();
  const { sendMessage, lastMessage, readyState, getWebSocket } = useWebSocket(
    getSocketUrl,
    options
  );

  const state = {
    [ReadyState.CONNECTING]: 'Connecting',
    [ReadyState.OPEN]: 'Open',
    [ReadyState.CLOSING]: 'Closing',
    [ReadyState.CLOSED]: 'Closed',
  }[readyState];

  useEffect(() => {
    console.log(lastMessage);
    if (lastMessage && lastMessage.data) {
      setLastLog(JSON.parse(lastMessage.data));
    }
  }, [lastMessage, setLastLog]);

  return { lastLog, state, error };
}
